var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link.external)?_c('a',{staticClass:"nav-link",class:{
    active: _vm.link.route.name === _vm.$route.name,
  },attrs:{"href":_vm.link.route}},[_c('span',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.link.name))]),_vm._v(" "),(_vm.link.new)?_c('span',{staticClass:"new"},[_vm._v("NEW!")]):_vm._e()])]):_c('router-link',{staticClass:"nav-link",class:{
    active: _vm.link.route.name === _vm.$route.name,
  },attrs:{"to":_vm.link.route}},[_c('span',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.link.name))]),_vm._v(" "),(_vm.link.new)?_c('span',{staticClass:"new"},[_vm._v("NEW!")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1640e06f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/NavLink.vue
// module id = null
// module chunks = 